module.exports = __webpack_public_path__ + "img/trackd-icon.8f905749.svg";